module.exports = __webpack_public_path__ + "media/images/default/homepage/about/bike-dc182fb3f60decdad4583ef67a788808.svg";